import { Box, darken, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../../utils/colors';

const SelectorAppBarButton = styled(Box)(({ theme }) => ({
  borderRadius: 24,
  color: spaceCadet[700],
  backgroundColor: darken(spaceCadet[300], 0.2),
  boxSizing: 'border-box',

  '&:has(> .selectButton:hover)': {
    backgroundColor: darken(spaceCadet[300], 0.12),
  },

  transition: theme.transitions.create(
    ['border-radius', 'background-color', 'color'],
    {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    },
  ),

  '& > .MuiButton-root': {
    minWidth: 0,
    padding: 12,
    borderRadius: 24,
    color: 'inherit',

    transition: theme.transitions.create(
      ['border-radius', 'background-color', 'color', 'transform'],
      {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      },
    ),

    '&.mainButton': {
      backgroundColor: spaceCadet[300],
      '&:hover': {
        borderRadius: 18,
      },
    },
    '&.selectButton': {
      backgroundColor: 'transparent',
      marginRight: -8,
      transform: 'rotate(180deg)',
    },
  },

  '&.selecting': {
    '&:not(.active)': {
      borderRadius: 18,
    },
    '& .selectButton': {
      transform: 'rotate(0deg)',
    },
  },

  '&.active': {
    borderRadius: 12,
    backgroundColor: ultraMarine[400],
    color: 'white',
    border: `2px solid ${ultraMarine[100]}`,

    '&:has(> .selectButton:hover)': {
      backgroundColor: darken(ultraMarine[400], 0.12),
    },

    '& > .MuiButton-root': {
      borderRadius: 10,
      padding: '10px 11px',

      '&:hover': {
        borderRadius: 10,
      },

      '&.mainButton': {
        backgroundColor: ultraMarine[500],
        '&:hover': {
          backgroundColor: ultraMarine[600],
        },
      },
    },
  },

}));

export default SelectorAppBarButton;
